import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetBookingSummaryReport } from "../services/reports.services";

const BookingSummaryReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/bookingsummaryreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/bookingsummaryreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterCreatedBy = params?.filterCreatedBy;
  const filterSector = params?.filterSector;
  const CustomerName = params?.CustomerName;
  const filterRequirementType = params?.filterRequirementType;
  const ConfirmStatus = params?.ConfirmStatus;

  const loading = useAppSelector((state) => state.reports.loading);
  const BookingSummaryListForReport = useAppSelector(
    (state) => state.reports.BookingSummaryListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        Destination: filterSector !== "0" ? filterSector : "",
        CreatedByName: filterCreatedBy !== "0" ? filterCreatedBy : "",
        CustomerName: CustomerName !== "0" ? CustomerName : "",
        RequirementType:
          filterRequirementType !== "0" ? filterRequirementType : "",
        ConfirmStatus: ConfirmStatus !== "0" ? ConfirmStatus : "",
      };
      dispatch(GetBookingSummaryReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "BookingSummaryReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "BookingSummaryreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Booking Summary Report{" "}
          <span style={{ fontSize: 15 }}>
            {BookingSummaryListForReport &&
              BookingSummaryListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            BookingSummaryListForReport &&
            BookingSummaryListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            BookingSummaryListForReport &&
            BookingSummaryListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {BookingSummaryListForReport && BookingSummaryListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th style={{ background: "black", color: "white" }}  className="text-center">No</th>
                <th style={{ background: "black", color: "white" }}  className="text-center">
                  Booking No
                </th>
                <th style={{ background: "black", color: "white" }}  className="text-center">Trip ID</th>
                <th style={{ background: "black", color: "white" }}  className="text-center">
                  Customer Name
                </th>
                <th style={{ background: "black", color: "white" }}  className="text-center">
                  Destination
                </th>
                <th style={{ background: "black", color: "white" }}  className="text-center">
                  Service Type
                </th>
                <th style={{ background: "black", color: "white" }}  className="text-center">
                  Booking Date
                </th>
                <th style={{ background: "black", color: "white" }}  className="text-center">
                  Booked By
                </th>
                <th style={{ background: "black", color: "white" }}  className="text-center">Status</th>
                <th style={{ background: "black", color: "white" }}  className="text-end">
                  Total Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {BookingSummaryListForReport &&
                BookingSummaryListForReport.length > 0 &&
                BookingSummaryListForReport?.map(
                  (BookingSummary: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {BookingSummary?.TourBookingNo || ""}
                      </td>
                      <td className="text-center">
                        {BookingSummary?.TripID || ""}
                      </td>
                      <td className="text-center">
                        {BookingSummary?.CustomerName || ""}
                      </td>
                      <td className="text-center">
                        {BookingSummary?.Destination || ""}
                      </td>
                      <td className="text-center">
                        {BookingSummary?.RequirementType || ""}
                      </td>
                      <td className="text-center">
                        {BookingSummary?.BookingDate
                          ? moment(
                              BookingSummary?.BookingDate,
                              "DD/MM/YYYY"
                            ).format("DD MMM YYYY")
                          : ""}
                      </td>
                      <td className="text-center">
                        {BookingSummary?.CreatedByName || ""}
                      </td>
                      <td className="text-center">
                        {BookingSummary?.ConfirmStatus || ""}
                      </td>
                      <td className="text-end">
                        {formatIndianNumber(BookingSummary?.GrandTotal) || ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default BookingSummaryReportView;
